import * as React from 'react';

function SvgJcbColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 56 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="JcbColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={31}
        y={3}
        width={8}
        height={22}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.595 3.14h6.674v21.108h-6.674V3.139z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#JcbColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.175 14.99c.074 2.161.149 4.394.038 6.593-.074.864-.629 1.692-1.442 2.197-.629.396-1.405.432-2.219.468l-2.939-.036-.018-18.335c.148-1.225 1.072-2.27 2.255-2.593 1.442-.18 2.773-.109 4.289-.145l.073.937v10.41l-.037.036v.468z"
          fill="#00A551"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.882 14.307V5.66c.185-.973.998-1.873 1.959-2.233 1.442-.433 3.106-.18 4.584-.217.074 1.406 0 3.17.037 4.396l.075 11.273c-.186 1.73.48 4.07-1.74 5.044-1.403.683-3.289.252-4.879.396l-.036-.252V14.306z"
        fill="#0071BB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.882 14.666c.59.757 1.405 1.332 2.402 1.369 1.22.108 2.81.216 3.623-.9.555-.577.223-1.369.334-2.126l-.038-1.369c-.702-.144-1.33 0-2.144-.036-.406 1.477.666 3.134-1.072 3.89-.407.109-.998.037-1.405-.215-.665-.145-.295-1.19-1.183-.901l-.517-.071v.36z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.819 4.4l.037 17.543c-.258.828-.924 1.728-1.848 2.053-1.405.467-3.143.252-4.695.252l-.075-18.479c.075-.865.666-1.62 1.442-2.089.555-.36 1.22-.47 1.923-.505h3.142L30.82 4.4z"
        fill="#EC1C24"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.523 11.64c.074.216 0 .397.037.649-1.11-.288-2.477-.613-3.475.18-.37.431-.592.865-.555 1.44.111.65.518 1.262 1.146 1.514.962.288 1.96.036 2.847-.181.037.18.074.432 0 .576H26.27c-.739-.144-1.33-.54-1.663-1.26-.296-.684-.148-1.62.37-2.197a2.183 2.183 0 011.774-.757l3.77.036zM35.736 14.018c-.702-.109-1.405-.072-2.07-.036-.037.54 0 .972.073 1.477.74 0 1.553.107 2.218-.217.186-.18.296-.468.223-.72-.037-.215-.223-.396-.444-.504zm-1.997-1.981c-.11.395-.11.937-.037 1.368.777-.035 1.775.252 2.292-.324.186-.217.075-.576-.037-.757-.591-.504-1.478-.18-2.218-.287zm4.436 2.954c-.11.432-.48.827-.924.9h-5.175l-.184-.073c0-1.44-.038-2.809.036-4.214h3.29c1.035.108 2.18-.324 2.662.613.148.324.11.756-.149 1.009-.147.25-.48.288-.554.467.407.108.85.433.998.829v.469z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgJcbColour;
